import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';

import { IStrapiDocument, UpdateDetails } from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import { Meta, Title } from '@angular/platform-browser';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { UniLookupComponent } from 'src/app/shared/components/uni-lookup/uni-lookup.component';
import { UniListComponent } from 'src/app/shared/components/uni-list/uni-list.component';
import { UniAddComponent } from 'src/app/shared/components/uni-add/uni-add.component';
import { University } from 'src/app/shared/models/university.model';
import { ResidenceLookupComponent } from 'src/app/shared/components/residence-lookup/residence-lookup.component';
import { ResidenceListComponent } from 'src/app/shared/components/residence-list/residence-list.component';
import { ResidenceAddComponent } from 'src/app/shared/components/residence-add/residence-add.component';
import { Residence } from 'src/app/shared/models/residence.model';
import { ResidenceService } from 'src/app/services/residence.service';
import { ApiSearchResponse } from 'src/app/interfaces/api';
import { User } from 'src/app/shared/models/user.model';
import { Router, RouterLink } from '@angular/router';
import { UniService } from 'src/app/services/uni.service';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { AuthService } from '../../../services/auth.service';
import { ModalComponent as ModalComponent_1 } from '../../../shared/components/modal/modal.component';
import { UniLookupComponent as UniLookupComponent_1 } from '../../../shared/components/uni-lookup/uni-lookup.component';
import { UniAddComponent as UniAddComponent_1 } from '../../../shared/components/uni-add/uni-add.component';
import { UniListComponent as UniListComponent_1 } from '../../../shared/components/uni-list/uni-list.component';
import { TooltipComponent } from '../../../shared/components/tooltip/tooltip.component';
import { ResidenceLookupComponent as ResidenceLookupComponent_1 } from '../../../shared/components/residence-lookup/residence-lookup.component';
import { ResidenceListComponent as ResidenceListComponent_1 } from '../../../shared/components/residence-list/residence-list.component';
import { ResidenceAddComponent as ResidenceAddComponent_1 } from '../../../shared/components/residence-add/residence-add.component';
import { ErrorBlockComponent } from '../../../shared/components/error-block/error-block.component';
import { SuccessBlockComponent } from '../../../shared/components/success-block/success-block.component';
import { ConfirmYourCoverComponent } from '../confirm-your-cover/confirm-your-cover.component';
import { TooltipModalComponent } from '../../../shared/components/tooltip-modal/tooltip-modal.component';

@Component({
    selector: 'app-update-insurance',
    templateUrl: './update-insurance.component.html',
    styleUrls: ['./update-insurance.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        ModalComponent_1,
        UniLookupComponent_1,
        UniAddComponent_1,
        UniListComponent_1,
        TooltipComponent,
        ResidenceLookupComponent_1,
        ResidenceListComponent_1,
        ResidenceAddComponent_1,
        ErrorBlockComponent,
        SuccessBlockComponent,
        RouterLink,
        ConfirmYourCoverComponent,
        TooltipModalComponent,
    ],
})
export class UpdateInsuranceComponent extends PageComponent implements OnInit {
  public override pageData: UpdateDetails = <UpdateDetails>{};

  public detailsForm!: UntypedFormGroup;

  public detailsSubmitted = false;

  public detailsError = false;

  public detailsSuccess = false;

  public updating = false;

  // uni lookup modal stuff
  @ViewChild('uniLookupModal') public readonly uniLookupModal!: ModalComponent;

  public showUniLookupModal = false;

  @ViewChild('uniLookup') public readonly uniLookup!: UniLookupComponent;

  public uniLookupSearchTerm = '';

  // uni list modal stuff
  @ViewChild('uniListModal') public readonly uniListModal!: ModalComponent;

  public showUniListModal = false;

  @ViewChild('uniList') public readonly uniList!: UniListComponent;

  // uni add modal stuff
  @ViewChild('uniAddModal') public readonly uniAddModal!: ModalComponent;

  public showUniAddModal = false;

  @ViewChild('uniAdd') public readonly uniAdd!: UniAddComponent;

  public addUniPrefill = '';

  @ViewChild('residenceLookupModal')
  public readonly residenceLookupModal!: ModalComponent;

  public showResidenceLookupModal = false;

  @ViewChild('residenceLookup')
  public readonly residenceLookup!: ResidenceLookupComponent;

  public residenceLookupSearchTerm = '';

  // residence list modal stuff
  @ViewChild('residenceListModal')
  public readonly residenceListModal!: ModalComponent;

  public showResidenceListModal = false;

  @ViewChild('residenceList')
  public readonly residenceList!: ResidenceListComponent;

  // residence add modal stuff
  @ViewChild('residenceAddModal')
  public readonly residenceAddModal!: ModalComponent;

  public showResidenceAddModal = false;

  @ViewChild('residenceAdd')
  public readonly residenceAdd!: ResidenceAddComponent;

  public addResidencePrefill = '';

  private selectedUniversity: University | null = null;

  private selectedResidence: Residence | null = null;

  public accommodationStayingText: string | null = '';

  public accommodationTooltipID: string | null = '';

  public showTooltipModal = false;

  public tooltipModalContent = '';

  public isPathwayProvider: boolean = false;

  public shouldShowCYC = false;

  public showConfirm = false;

  public isUnihome: boolean = false;

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,
    public override readonly strapi: StrapiService,
    public readonly auth: AuthService,
    private readonly user: UserService,
    private readonly residenceService: ResidenceService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router,
    private readonly uniService: UniService,
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    if (this.auth.currentUser) {
      this.selectedUniversity = this.auth.currentUser.university;
      this.selectedResidence = this.auth.currentUser.accommodation;

      if (
        this.selectedUniversity?.cmsId === 'unihomes' ||
        this.selectedUniversity?.cmsId === 'split-my-bills'
      ) {
        this.isUnihome = true;
      }
    }

    this.initializeForms();

    this.strapi
      .getDocumentsByType('update-detail', { populate: '*' })
      .subscribe((data: IStrapiDocument<UpdateDetails>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.cdr.markForCheck()
      });
  }

  /**
   * Initialize the update insurance form
   *
   * @returns void
   */
  public initializeForms(): void {
    const uniId = this.auth.currentUser?.university?.uuid ?? '';
    const uniName = this.auth.currentUser?.university?.name ?? '';
    const accomId = this.auth.currentUser?.accommodation?.uuid ?? '';
    const accomName = this.auth.currentUser?.accommodation?.name ?? '';
    const postcode = this.auth.currentUser?.postcode ?? '';

    this.uniLookupSearchTerm = String(uniName);
    this.residenceLookupSearchTerm = String(accomName);

    this.detailsForm = this.formBuilder.group({
      university_id: [uniId, { validators: [Validators.required.bind(this)] }],
      university_name: [uniName],
      residence_id: [accomId, { validators: [Validators.required.bind(this)] }],
      residence_name: [accomName],
      postcode: [postcode],
    });

    const markFieldAsInvalid = (fieldName: string) => {
      const field = this.detailsForm.get(fieldName);
      if (field?.value === '') {
        field.markAsDirty();
        field.markAsTouched();
      }
    };

    markFieldAsInvalid('university_name');
    markFieldAsInvalid('residence_name');

    if (this.isUnihome) {
      this.detailsForm
        .get('postcode')
        ?.setValidators([Validators.required.bind(this)]);
    }
  }

  protected override parsePageData(page: UpdateDetails): void {
    super.parsePageData(page);
    this.pageData = page;
    if (this.auth.currentUser) {
      this.setAccommodationFieldText(this.auth.currentUser?.university);
    }
  }

  public get detailsControl(): {
    [key: string]: AbstractControl;
  } {
    return this.detailsForm?.controls;
  }

  public submitDetailsForm(e: Event): void {
    e.preventDefault();
    this.detailsSubmitted = true;

    if (this.detailsForm.invalid) return;
    this.showConfirm = true;
  }

  public confirmModalClosed(doChanges: boolean): void {
    this.showConfirm = false;
    if (doChanges) this.doConfirm();
  }

  /**
   * On user confirm changes, submit the form
   *
   * @returns void
   */
  public doConfirm(): void {
    this.detailsSubmitted = true;

    if (this.detailsForm.invalid) return;

    const clone = User.fromJson(this.auth.currentUser!);
    clone.universityId = this.selectedUniversity?.uuid;
    clone.accommodationId = this.selectedResidence?.uuid;
    clone.postcode = this.detailsForm.get('postcode')?.value;

    this.updating = true;
    this.user.updateUser(clone).subscribe({
      next: () => {
        this.detailsSuccess = true;
        this.auth.userMustCompleteProfile = false;
        this.checkCYC();
      },
      error: () => {
        this.detailsSuccess = false;
        this.detailsError = true;
        this.updating = false;
      },
      complete: () => {
        this.detailsError = false;
        this.detailsSubmitted = false;
        this.updating = false;
        this.showConfirm = false;
        this.cdr.detectChanges();
      },
    });
  }

  private checkCYC(): void {
    if (!this.auth.currentUser?.accommodation.covered) {
      // if no cover, or already confirmed, back to the my insurance page
      this.router.navigate(['/app/my-insurance']).finally(() => false);
    } else {
      this.shouldShowCYC = true;
    }
  }

  public handleNotAtUni(): void {
    this.uniService.getImNotAtUniversityObject().subscribe({
      next: (university) => {
        const theUniResponse = <ApiSearchResponse>university;
        const uni = <University>theUniResponse.data;
        this.detailsForm.get('university_id')!.setValue(uni.uuid);
        this.detailsForm.get('university_name')!.setValue(uni.searchableName);
        this.selectedUniversity = uni;
        this.hideUniSelectionModals();
        this.accommodationStayingText = this.pageData.staying;
      },
    });
  }

  public displayUniLookupModal(): void {
    this.showUniLookupModal = true;
    this.uniLookup.giveFocus();
  }

  public displayUniListModal($event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.showUniListModal = true;
  }

  public universitySelected(university: University): void {
    this.hideUniSelectionModals();
    this.detailsForm.get('university_id')?.setValue(university.uuid);
    this.detailsForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm = university.name;
    this.addUniPrefill = university.name;
    this.selectedUniversity = university;
    this.setAccommodationFieldText(university);
  }

  public universityEntered(university: University): void {
    this.detailsForm.get('university_id')?.setValue(university.uuid);
    this.detailsForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm = university.name;
    this.showUniAddModal = false;
    this.selectedUniversity = university;
    this.accommodationStayingText = this.pageData.staying;
  }

  public hideUniSelectionModals(): void {
    this.showUniLookupModal = false;
    this.showUniListModal = false;
  }

  public changeShowAddUniModal(lookupTerm: string): void {
    this.hideUniSelectionModals();
    if (lookupTerm) {
      this.addUniPrefill = lookupTerm;
    }
    this.showUniAddModal = true;
  }

  public displayResidenceLookupModal(): void {
    this.showResidenceLookupModal = true;
    this.residenceLookup.giveFocus();
  }

  public displayResidenceListModal($event: Event): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.showResidenceListModal = true;
  }

  public residenceSelected(residence: Residence): void {
    this.hideResidenceSelectionModals();
    this.detailsForm.get('residence_id')?.setValue(residence.uuid);
    this.detailsForm.get('residence_name')?.setValue(residence.name);
    this.residenceLookupSearchTerm = residence.name;
    this.addResidencePrefill = residence.name;
    this.selectedResidence = residence;
  }

  public residenceEntered(residence: Residence): void {
    this.detailsForm.get('residence_id')?.setValue(residence.uuid);
    this.detailsForm.get('residence_name')?.setValue(residence.name);
    this.residenceLookupSearchTerm = residence.name;
    this.selectedResidence = residence;
  }

  public hideResidenceSelectionModals(): void {
    this.showResidenceLookupModal = false;
    this.showResidenceListModal = false;
  }

  public handleAlternateResidence(slug: string): void {
    this.residenceService.getResidenceBySlug(slug).subscribe({
      next: (residence) => {
        const theResidenceResponse = <ApiSearchResponse>residence;
        const res = <Residence>theResidenceResponse.data;
        this.detailsForm.get('residence_id')!.setValue(res.uuid);
        this.detailsForm.get('residence_name')!.setValue(res.name);
        this.selectedResidence = res;
        this.hideResidenceSelectionModals();
      },
    });
  }

  public onCoverModalDisplayChange(showModal: boolean): void {
    this.shouldShowCYC = showModal;
    if (!this.shouldShowCYC) {
      this.router.navigate(['/app/my-insurance']).finally(() => false);
    }
  }

  public openTooltip(id: string) {
    this.showTooltipModal = true;

    type PageDataIndex = keyof typeof this.pageData;

    const currentRoute = id as PageDataIndex;
    this.tooltipModalContent = this.pageData[currentRoute] as string;
  }

  private setAccommodationFieldText(uni: University): void {
    if (!uni) return;
    this.isPathwayProvider = uni.is_pathway_provider;
    if (uni.is_pathway_provider) {
      this.accommodationStayingText = this.pageData.staying_pathway_provider;
      return;
    }
    this.accommodationStayingText = this.pageData.staying;
  }

  /**
   * open model for the user to confirm they are no longer a customer
   */
  public noLongerAUniHomeCustomer(): void {}
}
